import { Theme } from '@emotion/react';
import IconButton from '@mui/material/IconButton';
import { SxProps } from '@mui/material/styles';

import styled from '@emotion/styled';
import CircularProgress from '@mui/material/CircularProgress';

interface IconButtonProps extends React.HTMLProps<HTMLButtonElement> {
    ariaLabel: string;
    imageStyle?: Record<string, any>;
    sx?: SxProps<Theme>;
    isLoading?: boolean;
    disableRipple?: boolean;
    className?: string;
    show?: boolean;
    disabled?: boolean;
    testId?: string;
}

const LoaderWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export default function ({
    children,
    src,
    onClick = () => {},
    sx,
    imageStyle: imageSx = {},
    ariaLabel,
    className,
    isLoading = false,
    disableRipple = false,
    show = true,
    disabled,
    testId,
}: IconButtonProps) {
    return show ? (
        <IconButton
            hidden
            className={className}
            sx={sx}
            onClick={onClick}
            aria-label={ariaLabel}
            disabled={isLoading || disabled}
            disableRipple={disableRipple}
            data-testid={testId}>
            {isLoading ? (
                <LoaderWrapper>
                    <CircularProgress color="inherit" size={16} />
                </LoaderWrapper>
            ) : src ? (
                <img style={imageSx} src={src} alt="" />
            ) : null}
            {children}
        </IconButton>
    ) : null;
}
